/* eslint-disable */
<template>
  <footer class="text-center text-md-left">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-lg-4 col-xl-4">
          <h2>Contact Us</h2>
          <ul class="row">
            <li class="col-md-6 col-lg-12">
              75 Manson Green, Hingham,
              <br />Norfolk, NR9 4PZ UK.
            </li>
            <li class="col-md-6 col-lg-12 mt-3 mt-md-0 mt-lg-3">
              <strong>
                <a href="tel:07912877887" class="phone">
                  <span class="text">07912877887</span>
                </a>
              </strong>
              <br />
              <strong>
                <a href="mailto:info@kd-roofing.com">
                  <span class="text">info@kd-roofing.com</span>
                </a>
              </strong>
            </li>
          </ul>
        </div>
        <div class="col-md-6 col-lg-4 col-xl-4">
          <h2>Sections</h2>
          <ul>
            <li>
              <router-link to="/about/">
                <span class="icon-chevron-right"></span>
                <span class="text">About</span>
              </router-link>
            </li>
            <li>
              <router-link to="/services/">
                <span class="icon-chevron-right"></span>
                <span class="text">Services</span>
              </router-link>
            </li>
            <li>
              <router-link to="/gallery/">
                <span class="icon-chevron-right"></span>
                <span class="text">Gallery</span>
              </router-link>
            </li>
            <li>
              <router-link to="/contact/">
                <span class="icon-chevron-right"></span>
                <span class="text">Contact</span>
              </router-link>
            </li>
            <li>
              <router-link to="/privacy-policy/">
                <span class="icon-chevron-right"></span>
                <span class="text">Privacy Policy</span>
              </router-link>
            </li>
            <li>
              <router-link to="/cookie-policy/">
                <span class="icon-chevron-right"></span>
                <span class="text">Cookie Policy</span>
              </router-link>
            </li>
          </ul>
        </div>
        <div class="col-md-6 col-lg-4 col-xl-3 left-padding">
          <h2>Follow Us</h2>
          <ul>
            <li>
              <a
                class="social"
                target="_blank"
                rel="nofollow noopener"
                href="https://www.facebook.com/KDROOFIN/"
              >
                <span class="icon">
                  <span class="icon-facebook-f"></span>
                </span>
                <span class="text">Facebook</span>
              </a>
              <!-- <a class="social"
                 target="_blank"
                 rel="nofollow"
                 href="#">
                <span class="icon">
                  <span class="icon-linkedin"></span>
                </span>
                <span class="text">LinkedIn</span>
              </a>-->
            </li>
            <li>
              <a
                class="social"
                target="_blank"
                rel="nofollow noopener"
                href="https://twitter.com/kd_roofing"
              >
                <span class="icon">
                  <span class="icon-twitter"></span>
                </span>
                <span class="text">Twitter</span>
              </a>
              <!-- <a class="social"
                   target="_blank"
                   rel="nofollow"
                   href="#">
                  <span class="icon">
                    <span class="icon-google-plus-circle"></span>
                  </span>
                  <span class="text">Google+</span>
              </a>-->
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="container copyright-container">
        <div class="copyright">
          <span>Copyright &copy; KD Roofing. All Rights Reserved {{copyrightDate}}.</span>
        </div>
        <div class="netmatters-design">
          <p>
            <a
              href="https://www.netmatters.co.uk"
              target="_blank"
              rel="nofollow noopener"
            >Website Design</a> by
            <span>
              <a
                href="https://www.netmatters.co.uk"
                target="_blank"
                rel="nofollow noopener"
              >Netmatters</a>
            </span>
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      name: "main-footer",
      copyrightDate: "",
    };
  },
  mounted() {
    this.copyrightDate = new Date().getFullYear();
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/partials/MainFooter.vue